
import { useQuery } from 'react-query';
import { Order } from '../utils/table';
import { getHubActivationMap } from '../services/hubs';

export const useGetHubActivationMap = ({
  orderBy,
  order,
  filters,
  }: {
  order: Order,
  orderBy: string,
  filters: {
    communityIds: string[],
    propertyIds: string[],
    activatedBy: string[],
  }
}) => useQuery(
  ['hubActivationMap', order, orderBy, filters],
  () => getHubActivationMap({
    orderBy, order, filters,
  }),
  {
    refetchOnWindowFocus: false,
  },
);
